export function TimerAdd({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4619 10.2119C16.4618 9.35837 15.7688 8.67383 14.9238 8.67383H11.5C11.2591 8.67383 11.0326 8.55862 10.8916 8.36328C10.7507 8.16807 10.7124 7.91698 10.7881 7.68848L11.9248 4.26367L11.9707 4.15332C12.0982 3.90825 12.354 3.75 12.6367 3.75H17.2119L17.2891 3.75391C17.6671 3.79245 17.9619 4.11177 17.9619 4.5C17.9619 4.88823 17.6671 5.20755 17.2891 5.24609L17.2119 5.25H13.1777L12.5391 7.17383H14.9238C16.5909 7.17383 17.9618 8.52364 17.9619 10.2119C17.9619 11.879 16.6123 13.25 14.9238 13.25H11.5C11.0858 13.25 10.75 12.9142 10.75 12.5C10.75 12.0858 11.0858 11.75 11.5 11.75H14.9238C15.7775 11.75 16.4619 11.057 16.4619 10.2119ZM7.5 7.75C7.91421 7.75 8.25 8.08579 8.25 8.5C8.25 8.91421 7.91421 9.25 7.5 9.25H5.25V11.5C5.25 11.9142 4.91421 12.25 4.5 12.25C4.08579 12.25 3.75 11.9142 3.75 11.5V9.25H1.5C1.08579 9.25 0.75 8.91421 0.75 8.5C0.75 8.08579 1.08579 7.75 1.5 7.75H3.75V5.5C3.75 5.08579 4.08579 4.75 4.5 4.75C4.91421 4.75 5.25 5.08579 5.25 5.5V7.75H7.5Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
